// hooks/NewCaseView/useCaseData.js
import { useState, useEffect } from "react";
import { Endpoint } from "../../api/base";

/**
 * Hook to fetch and manage clients and field resources data
 */
export const useCaseData = () => {
  const [clientList, setClientList] = useState([]);
  const [clientSelect, setClientSelect] = useState([]);
  const [fieldResourceList, setFieldResourceList] = useState([]);
  const [fieldResourceSelect, setFieldResourceSelect] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch clients
  const fetchClients = async () => {
    try {
      const res = await Endpoint.getClients();
      setClientList(res.data);

      const options = res.data.map((element) => ({
        value: element.client_id,
        label: element.client_name,
      }));
      setClientSelect(options);
    } catch (err) {
      console.error("Error fetching clients:", err);
      setError(err);
    }
  };

  // Fetch field resources
  const fetchFieldResources = async () => {
    try {
      const res = await Endpoint.getFieldResources();
      setFieldResourceList(res.data);

      const options = res.data.map((element) => ({
        value: element.id,
        label: element.name,
      }));
      setFieldResourceSelect(options);
    } catch (err) {
      console.error("Error fetching field resources:", err);
      setError(err);
    }
  };

  // Fetch both on mount
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await Promise.all([fetchClients(), fetchFieldResources()]);
      setLoading(false);
    };

    fetchData();
  }, []);

  return {
    clientList,
    clientSelect,
    fieldResourceList,
    fieldResourceSelect,
    loading,
    error,
    refetchClients: fetchClients,
    refetchFieldResources: fetchFieldResources,
  };
};

export default useCaseData;
